import type { ReactNode } from "react";
import { BrandMark } from "@/components/brand-mark";
import { ThemeToggle } from "@/components/theme-toggle";

type Props = {
  children: ReactNode;
  /** Rendered outside the card, centered under it. */
  footer?: ReactNode;
  /** Tone controls the ambient glow. `subdued` used for superadmin. */
  tone?: "brand" | "subdued";
};

export function AuthShell({ children, footer, tone = "brand" }: Props) {
  return (
    <div className="relative min-h-screen bg-background text-foreground bg-grain overflow-hidden">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 -top-40 h-[420px] opacity-50 blur-3xl"
        style={{
          background:
            tone === "brand"
              ? "radial-gradient(60% 50% at 50% 40%, hsl(var(--brand) / 0.28), transparent 70%)"
              : "radial-gradient(60% 50% at 50% 40%, hsl(var(--foreground) / 0.06), transparent 70%)",
        }}
      />
      <header className="relative z-10 flex items-center justify-between px-4 py-4 md:px-8 md:py-6">
        <BrandMark />
        <ThemeToggle />
      </header>
      <main className="relative z-10 mx-auto flex w-full max-w-md flex-col items-stretch px-4 pt-8 pb-16 md:px-6 md:pt-12 md:pb-24">
        {children}
        {footer}
      </main>
    </div>
  );
}
